import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';
import { CustomNextImage as Image } from '@crehana/next';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { PrimaryButton } from '@crehana/ui';

import { imgixLoader } from '@/shared/utils/imgixLoader';
import { useExcelImporterStepperContext } from '@/views/AdminDashboard/components/ExcelImporterStepper/context';

import ContextInjectedWrapper from './ContextInjectedWrapper/ContextInjectedWrapper';

const defaultImage =
  'https://crehana-vercel-images-prd.imgix.net/public/cd5d51e9-007f-4282-a927-3f0bcfc3ae9b-420x420.png?auto=format&fit=clip';

const Step3: FC = () => {
  const { t } = useTranslation();
  const { panelUrl, customFinalStep: CustomFinalStep } =
    useExcelImporterStepperContext();

  if (CustomFinalStep) {
    return <ContextInjectedWrapper component={CustomFinalStep} />;
  }

  return (
    <div className="flex flex-col items-center justify-center h-full p-16 m-auto">
      <div className="relative w-full mb-20" css={{ height: '272px' }}>
        <Image
          loader={imgixLoader}
          src={defaultImage}
          objectFit="contain"
          objectPosition="center"
          layout="fill"
          loading="lazy"
          alt="Success upload csv"
        />
      </div>
      <p className="font-h4 pb-12 dark:tw-text-neutral-light-100">
        {t('STEP_3_SUCCESS_TITLE')}
      </p>
      <p className="font-body3 pb-24 whitespace-pre-line text-center dark:tw-text-neutral-light-100">
        {t('STEP_3_SUCCESS_SUBTITLE')}
      </p>
      <div className="tw-flex-col tw-items-center tw-w-full tw-justify-center">
        <div className="tw-flex tw-gap-2 tw-w-full tw-justify-center tw-mb-2">
          <PrimaryButton size="m" label={t('STEP_3_BUTTON')} href={panelUrl} />
        </div>
      </div>
    </div>
  );
};

export default Step3;
